import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@types+node@20.17.9_eslint@9.16.0_rollup@4.28.0_typescript@5.7.2_vite@5.4.11/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@types+node@20.17.9_eslint@9.16.0_rollup@4.28.0_typescript@5.7.2_vite@5.4.11/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}